import React, { useMemo } from 'react';
import { PredefinedPhrase } from '../../PredefinedPhrasesSetup/PredefinedPhrasesList';
// @ts-ignore
import styles from './PredefinedPhraseSelectionItem.module.scss';
import useFilters from '../../../../Base/Hooks/useFilters';

interface Props {
	item: PredefinedPhrase;
	onSelect: (item: PredefinedPhrase) => void;
}

const PredefinedPhraseSelectionItem: React.FC<Props> = ({ item, onSelect }) => {
	const { checkEmptyString } = useFilters();

	const text: string = useMemo(() => {
		return checkEmptyString(item.name) ? item.name : item.value;
	}, [item]);

	return (
		<div className={styles.wrapper} onClick={() => onSelect(item)}>
			{text}
		</div>
	);
};

export default PredefinedPhraseSelectionItem;
